import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { IDataSourceBackendParam, ITPDAInfos } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { TPDAsService } from "./tpdas.service";

export class TPDAsDataSource extends MatTableDataSourceBackendExtended<ITPDAInfos> {
  public rawData$ = this.dataSubject.asObservable();

  constructor(private tpdasService: TPDAsService) {
    super();
  }

  public data(params: IDataSourceBackendParam): Observable<ITPDAInfos[]> {
    return this.tpdasService.getTPDAInfos(params);
  }
  protected dataCount(param: IDataSourceBackendParam): Observable<number> {
    return this.tpdasService.getNbTPDAInfos(param.lang, param.search, param.filters, param.services);
  }
}
